import { render, staticRenderFns } from "./StudentModeOn.vue?vue&type=template&id=db7f3ba0&scoped=true"
import script from "./StudentModeOn.vue?vue&type=script&lang=js"
export * from "./StudentModeOn.vue?vue&type=script&lang=js"
import style0 from "./StudentModeOn.vue?vue&type=style&index=0&id=db7f3ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7f3ba0",
  null
  
)

export default component.exports